import { Agency, Agent, CoveredGeo } from '../../../providers/api/dtos';
import { BrandTemplateAutofillAgencyData, BrandTemplateAutofillAgentData } from '../../utils/autofill/types';

export function getMainAgency(agencies: Agency[] | undefined): Agency | undefined {
  if (!agencies?.length) return undefined;

  return agencies[0];
}

export function getMostCoveredGeo(coveredGeo: CoveredGeo[] | undefined): CoveredGeo | undefined {
  if (!coveredGeo || !coveredGeo.length) return undefined;

  const mostCoveredGeo = coveredGeo.reduce((max, geo) => (geo.weight > max.weight ? geo : max));

  return mostCoveredGeo;
}

export const mapAgentToAutofillAgentData = (agent: Agent): BrandTemplateAutofillAgentData => ({
  photoId: agent.photoId,
  name: agent.name.name,
  surname: agent.name.surname,
  fullName: agent.name ? `${agent.name.name} ${agent.name.surname}` : undefined,
  email: agent.email.work,
  mobile: agent.mobile.work,
  jobTitle: agent.jobTitle,
  mainAgency: getMainAgency(agent.agencies),
  agencies: agent.agencies,
  coveredGeos: agent.coveredGeo,
  mostCoveredGeo: getMostCoveredGeo(agent.coveredGeo),
  bio: agent.personalInfo?.bio,
  moneySavedAvg: 7012,
  salesTimeAvg: {
    time: 161,
    unit: 'DAYS',
  },
});

export const mapAgencyToAutofillAgencyData = (agency: Agency): BrandTemplateAutofillAgencyData => ({
  address: agency.address,
  shortName: agency.shortName,
  phoneNumber: agency.phoneNumber,
});
